import PropTypes from 'prop-types';
import { useContext } from 'react';
import { PAYMENT_DETAILS } from 'src/common/constants/localizations/subscription';
import { LocationAndLocalizationContext } from '../../../../providers/LocationAndLocalizationProvider';
import settings from '../../account-settings.module.scss';
import css from '../subscription.module.scss';

export const PaymentDetails = ({ children }) => {
  const { getLocalizedText } = useContext(LocationAndLocalizationContext);

  return (
    <div className={css.paymentDetails}>
      <div className={settings.section}>
        <h3 data-testid="paymentDetailsTitle">{getLocalizedText(PAYMENT_DETAILS)}:</h3>
      </div>
      <div className={settings.section}>{children}</div>
    </div>
  );
};

PaymentDetails.propTypes = {
  children: PropTypes.node.isRequired,
};

export default PaymentDetails;
